import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    /* Rows: header / description / images. Empty rows collapse to zero
       height, so one template covers every content combination. */
    .homie-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    h2 {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    h3 {
      /* Tile captions pin the title-small scale (16/20 -> 18/24) so the
         full-size h3 default doesn't inflate them. */
      padding-top: calc(4rem / var(--default-rem-px-count));
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
      font-weight: var(--fw-regular);
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .has-images {
      h2 {
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }
      .description {
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }
    }

    /* Tile grid: single column on mobile, nested 12-col grid at 600px. */
    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: var(--between-row-padding-lg) var(--between-column-padding-lg);
    }

    img {
      display: block;
      width: 100%;
    }

    @media (min-width: 600px) {
      /* Top-row texts share a first baseline. */
      h2 {
        grid-column: 2 / 7;
        align-self: baseline;
      }

      h3 {
        padding-top: calc(10rem / var(--default-rem-px-count));
      }

      .description {
        grid-row: 2;
        grid-column: 8 / 13;
        align-self: baseline;
      }

      .has-images {
        h2 {
          margin-bottom: calc(80rem / var(--default-rem-px-count));
        }
        .description {
          margin-bottom: calc(80rem / var(--default-rem-px-count));
        }
      }

      .images {
        grid-row: 3;
        grid-column: 2 / 14;
        grid-template-columns: repeat(12, minmax(0, 1fr));
      }

      /* Three tiles per row, edges on the page grid lines. */
      .image-wrapper {
        grid-column: span 4;
      }
    }
  `,
];
